const useModalHandlers = (
  attributes,
  setModalTitle,
  setModuleName,
  setIsModalVisible,
  setFormData,
  setAttributesData
) => {
  const showModal = (name) => {
    setModalTitle(name);
    setModuleName(name);
    setIsModalVisible(true);
    const matchedSection = attributes && attributes.find((section) => section && section.name === name);
    console.log("name & match", name, matchedSection);
    setAttributesData(matchedSection || null);
  };

  const updateModal = (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("Update");
    const matchedSection =
      attributes && attributes.find((section) => section && section.name === record.module);
    setAttributesData(matchedSection || null);
  };

  const viewModal = (record) => {
    if (!record) return;
    setFormData(record);
    setIsModalVisible(true);
    setModalTitle("View Item");
    const matchedSection =
      attributes && attributes.find((section) => section && section.name === record.module);
    setAttributesData(matchedSection || null);
  };
  const handelCloseModal = () => {
    setIsModalVisible(false);
    setAttributesData(null);
    setFormData(null);
  };

  return { showModal, updateModal, viewModal, handelCloseModal };
};

export default useModalHandlers;
